import { Color, Group } from '@makeswift/runtime/controls';

import { FontFamily } from '~/lib/makeswift/controls/font-tokens';
import { hsl } from '~/lib/makeswift/utils/color';

import { colors } from '../base-colors';

export const footer = Group({
  label: 'Footer',
  preferredLayout: Group.Layout.Popover,
  props: {
    background: Color({ label: 'Background', defaultValue: hsl(colors.background.primary.black) }),
    borderTop: Color({ label: 'Border top', defaultValue: hsl(colors.contrast[100]) }),
    contactTitle: Color({ label: 'Contact title', defaultValue: hsl(colors.text.white) }),
    contactText: Color({ label: 'Contact text', defaultValue: hsl(colors.text.white) }),
    socialIcon: Color({ label: 'Social icon', defaultValue: hsl(colors.text.white) }),
    socialIconHover: Color({ label: 'Social icon hover', defaultValue: hsl(colors.primary) }),
    sectionTitle: Color({ label: 'Section title', defaultValue: hsl(colors.text.white) }),
    link: Color({ label: 'Footer link', defaultValue: hsl(colors.text.white) }),
    linkHover: Color({ label: 'Footer link hover', defaultValue: hsl(colors.primary) }),
    copyright: Color({ label: 'Footer copyright', defaultValue: hsl(colors.foreground) }),
    focus: Color({ label: 'Focus', defaultValue: hsl(colors.primary) }),
    titleFontFamily: FontFamily({ label: 'Font', defaultValue: FontFamily.Heading }),
    copyrightBackground: Color({
      label: 'Copyright Background',
      defaultValue: hsl(colors.background.primary.default),
    }),
  },
});
